import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { blogPosts } from '../mock';

const BlogSection = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#C75B27] font-medium mb-2">Actualités</div>
          <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">À découvrir</h2>
        </div>
        <Link to="/blog" className="hidden md:inline-flex items-center gap-1 text-[#1F4D3F] hover:text-[#173B30] font-medium">
          Voir tous les articles <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {blogPosts.map((post) => (
          <a key={post.id} href="#" className="card-hover bg-white border border-[#E8E0D0] rounded-2xl overflow-hidden flex flex-col">
            <div className="relative aspect-[16/10] overflow-hidden bg-[#FAF7F2]">
              <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" />
              {post.sponsored && (
                <div className="absolute top-3 left-3 bg-white/95 text-[#7A6F5C] text-[10px] uppercase tracking-wider px-2 py-1 rounded border border-[#E8E0D0]">
                  Sponsorisé
                </div>
              )}
              <div className="absolute top-3 right-3 bg-[#1F4D3F] text-white text-[10px] uppercase tracking-wider px-2 py-1 rounded">
                {post.category}
              </div>
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <h3 className="font-serif text-lg font-semibold text-[#2D2A26] leading-snug">{post.title}</h3>
              <p className="mt-2 text-sm text-[#7A6F5C] line-clamp-3 flex-1">{post.excerpt}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-sm text-[#1F4D3F] font-medium">
                Lire maintenant <ArrowRight className="w-3.5 h-3.5" />
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
